import { render, staticRenderFns } from "./kanumaCalc.vue?vue&type=template&id=87d68de4&scoped=true"
import script from "./kanumaCalc.vue?vue&type=script&lang=js"
export * from "./kanumaCalc.vue?vue&type=script&lang=js"
import style0 from "./kanumaCalc.vue?vue&type=style&index=0&id=87d68de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d68de4",
  null
  
)

export default component.exports